import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Server from '../../functions/server';
import getFormatedDate from '../../functions/date';
import $ from "jquery";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Getstatement from '../Sales/CustomerStatement/getstatement';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Loading from '../loadings';
import { Popup } from 'semantic-ui-react';

const styles = theme => ({
  form: {
    display: 'flex', flexDirection: 'column',
    margin: 'auto', width: 'fit-content',
  },
  formControl: { marginTop: theme.spacing.unit * 2, minWidth: 120 },
  formControlLabel: { marginTop: theme.spacing.unit },
});

class Customerdetails extends React.Component {

  state = {
    openDetails: false, fullWidth: true, menuPermission: [],
    maxWidth: 'md', customerDetails: [],
    from_date: getFormatedDate(new Date(), 'fromDate'),
    to_date: getFormatedDate(new Date(), 'toDate'),
  };

  getCustomerDetails() {
    let context = this;
    context.setState({ load: true, message: 'Getting Customer' });
    let data1 = { 'customer_id': this.props.customerId }
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'customer/customerdetails.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ customerDetails: data, openDetails: true, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });

  }

  handleClose = () => { this.setState({ openDetails: false }); };

  stringReducers(value) {
    try {
      if (value.length > 18) {
        value = value.substring(0, 10);
        value = value+'...';
      }
    } catch (e) {
    }
    return value;
  }

  getCustomerStatement(selectedCustomer, selectedCustomerName, getClosingbalance) {
    this.setState({
      customerStatement: true,
      selectedCustomer, 
      selectedCustomerName, 
      getClosingbalance
    })
  }

  render() {
    const { classes } = this.props;
    let customername = this.stringReducers(this.props.customerName);
    return (
      <div>
        <Popup content={this.props.customerName} trigger={<u style={{color: '#6E96D3'}} id="pointer"
        onClick={this.getCustomerDetails.bind(this)}>
        <div style={{color: 'black'}}>{this.props.customerId+'->'+customername}</div>
        </u>} />
        <React.Fragment>

        <Dialog fullWidth={true}
          maxWidth={'lg'}  open={this.state.customerStatement}
          onClose={ () => { this.setState({ customerStatement: false }) }} 
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Detailed Statement</DialogTitle>
          <DialogContent>
            <Getstatement menuPermission={this.state.menuPermission} fromDate={this.state.from_date} toDate={this.state.to_date} id={this.state.selectedCustomer} customername={this.state.selectedCustomerName} getClosingbalance={this.state.getClosingbalance} />
          </DialogContent>
        </Dialog>


          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
            open={this.state.openDetails} onClose={this.handleClose}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Customer Details</DialogTitle>
            <DialogContent>
            { this.state.customerDetails.map((z) => {
                let points = z.points;
                let outstanding_balance = z.outstanding_balance;
                try {
                  points = Number(points).toFixed(2);
                  outstanding_balance = Number(outstanding_balance).toFixed(2);
                } catch (e) {

                }
                return (
                  <Paper>
                    <Table>
                      <TableBody>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>ID</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.id}</TableCell>
                            <TableCell style={{fontSize: 16}}>Name</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Mobile</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.mobile}</TableCell>
                            <TableCell style={{fontSize: 16}}>Alt Mobile</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.alt_mobile}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Email</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.email_id}</TableCell>
                            <TableCell style={{fontSize: 16}}>Date Of Birth</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.dob}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Executive Name</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.executive_name}</TableCell>
                            <TableCell style={{fontSize: 16}}>Executive Number</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.executive}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Address</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.address}</TableCell>
                            <TableCell style={{fontSize: 16}}>Taluk</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.taluk}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>District</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.district}</TableCell>
                            <TableCell style={{fontSize: 16}}>Pincode</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.pincode}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Machine Number</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.machine_no}</TableCell>
                            <TableCell style={{fontSize: 16}}>Active From</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.timestamp}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Last Log</TableCell>
                            <TableCell style={{fontSize: 16}}>{z.last_log}</TableCell>
                            <TableCell style={{fontSize: 16}}>Outstanding Balance</TableCell>
                            <TableCell style={{fontSize: 16, cursor: 'pointer'}} onClick={this.getCustomerStatement.bind(this, z.id, z.name, outstanding_balance)}>{outstanding_balance}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{fontSize: 16}}>Points</TableCell>
                            <TableCell style={{fontSize: 16}}>{points}</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                )
              })
            }
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
      </div>
    );
  }
}

Customerdetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Customerdetails);
